"use client";

import { toast } from "sonner";
import { appUri, BRAND } from "./brand";

/**
 * "Continue in the app": hands this content to the installed Gerama app
 * (phone or desktop) through its URL scheme. If nothing takes over — the page
 * is still in front a moment later — the app isn't installed, so the visitor
 * goes to the download page instead of being left on a silent no-op.
 */
export function openInApp(path: string) {
  const started = Date.now();
  let left = false;
  const onHide = () => {
    if (document.visibilityState === "hidden") left = true;
  };
  document.addEventListener("visibilitychange", onHide);
  window.addEventListener("blur", onHide);

  toast.info(`در حال باز کردن در اپلیکیشن ${BRAND}…`);
  window.location.href = appUri(path);

  window.setTimeout(() => {
    document.removeEventListener("visibilitychange", onHide);
    window.removeEventListener("blur", onHide);
    // Still here after the attempt (and not a long-delayed tab) → no app answered.
    if (!left && document.visibilityState === "visible" && Date.now() - started < 4000) {
      window.location.assign("/download");
    }
  }, 1600);
}
